/**
 * 加權平均收盤價
 */
export function weightedClose() {
    const high = this.ohlc.highArray;
    const low = this.ohlc.lowArray;
    const close = this.ohlc.closeArray;
    return (2 * close.get(0) + high.get(0) + low.get(0)) * 0.25;
}
